import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import CategoryNav from '@/components/feature/CategoryNav';
import HotRecommend from '@/components/feature/HotRecommend';
import LatestUpdate from '@/components/feature/LatestUpdate';
import Ranking from '@/components/feature/Ranking';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { siteInfo } from '@/mocks/anime';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: siteInfo.name,
      url: 'https://www.51dongman.com',
      description: siteInfo.description,
      email: siteInfo.email,
      telephone: siteInfo.phone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: siteInfo.address,
        addressCountry: 'CN',
      },
    },
    {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: 'https://www.51dongman.com',
      description: siteInfo.description,
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.51dongman.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://www.51dongman.com/#webpage',
      url: 'https://www.51dongman.com',
      name: '51动漫官网首页 - 免费日漫韩漫国漫全集下拉式在线阅读',
      description: siteInfo.description,
      isPartOf: { '@id': 'https://www.51dongman.com/#website' },
      about: { '@id': 'https://www.51dongman.com/#organization' },
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <main>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        <Navbar />
        <Hero />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />
        <Ranking />
        <Footer />
      </main>
    </>
  );
}